module.exports = __webpack_public_path__ + "img/top2-1.252f80cc.png";